import { Storage } from './storage';

export class Multilingual {

  public static applyingLanguage: string = "vi";

  private static contents: { [key: string]: MultilingualContent } = {};  

  public static getContent(key: string): MultilingualContent {

    if (key == null) return null;

    if (typeof this.contents[key] == "undefined") {
      this.contents[key] = new MultilingualContent();

      let keys: string[] = [];
      for (let o in this.contents) keys.push(o);

      Storage.set("multilingual", keys);
    }

    return this.contents[key];
  }

  public static getText(key: string, language?: string): string {

    if (typeof language == "undefined") language = this.applyingLanguage;

    if (key == null || language == null) return null;
    return this.getContent(key).get(language, key);
  }
}

export class MultilingualContent {

  private contents: { [key: string]: string } = {};

  public get(language: string, defaultValue: string = null): string {
    if (typeof this.contents[language] == 'undefined') this.contents[language] = null;

    return this.contents[language] == null ? defaultValue : this.contents[language];
  }

  public set(language: string, value: string): void {
    this.contents[language] = value;
  }
}
